module.exports = __webpack_public_path__ + "img/scheduled.a220f4b7.svg";